/*
    nsBlinker directive - This will cause the HTML to blink for three seconds
    ex: <div ns-blinker="blinking"></div>
    where blinking can be a scope variable or a boolean
 */
import {utilModule} from '../module.js';

utilModule.directive('nsBlinker',['$timeout','$parse', function($timeout,$parse) {
    const lowercase = function(string){return isString(string) ? string.toLowerCase() : string;};
    // copy toBoolean from angular.js
    function toBoolean(value) {
        if (typeof value === 'function') {
            value = true;
        } else if (value && value.length !== 0) {
            let v = lowercase("" + value);
            value = !(v == 'f' || v == '0' || v == 'false' || v == 'no' || v == 'n' || v == '[]');
        } else {
            value = false;
        }
        return value;
    }
    function isString(value){return typeof value === 'string';}

    let MAX_BLINKING_TIME = 3;

    return {
        restrict: 'A',
        link: function(scope, ele, attr) {
            scope.$watch(attr.nsBlinker, function(newValue) {
                let timeLeft = MAX_BLINKING_TIME;

                function showElement() {
                    ele.css("display", "inline");
                    if (timeLeft > 0) {
                        timeLeft--;
                        $timeout(hideElement, 1000); // call hideElement after 1s
                    } else {
                        if (attr.nsBlinker && isString(attr.nsBlinker)) {
                            let model = $parse(attr.nsBlinker);  // get the model using the expression set in ns-blinker
                            model.assign(scope, false);  // assign the value of blinking
                            scope.$apply(); // apply it back to the scope
                        }
                    }
                }

                function hideElement() {
                    ele.css("display", "none");
                    $timeout(showElement, 200); // call showElement after 200ms
                }

                if (toBoolean(newValue)) {
                    hideElement();
                }
            });
        }
    }
}]);
